import React from "react";
import { ArrowDownRight, Sparkles } from "lucide-react";
import { resolveImage } from "../lib/api";

const Hero = ({ site, about }) => {
  const hero = site?.hero || {};
  const photo = hero.image || about?.designer_image;

  return (
    <section
      className="relative overflow-hidden"
      style={{
        background:
          "linear-gradient(180deg, var(--bg) 0%, color-mix(in oklab, var(--violet-soft) 55%, var(--bg)) 100%)",
      }}
    >
      <div className="relative max-w-7xl mx-auto px-5 md:px-8 pt-10 md:pt-20 pb-10 md:pb-16">
        <div className="grid md:grid-cols-12 gap-8 md:gap-10 items-center">
          {/* LEFT: text, fully left-aligned */}
          <div className="md:col-span-6 lg:col-span-7 text-left">
            {hero.badge_text && (
              <span
                data-testid="hero-badge"
                className="inline-flex items-center gap-2 px-3.5 py-1.5 rounded-full text-xs md:text-sm bg-[color:var(--card)] border border-[color:var(--card-border)] shadow-sm text-[color:var(--ink)]"
              >
                <Sparkles className="w-3.5 h-3.5 text-[color:var(--violet)]" /> {hero.badge_text}
              </span>
            )}

            <h1
              data-testid="hero-heading"
              className="mt-6 font-display font-semibold tracking-tight leading-[1.02] text-[clamp(2.4rem,6vw,4.6rem)]"
            >
              {hero.heading_pre}{" "}
              <span className="italic text-[color:var(--violet)]">{hero.heading_em}</span>{" "}
              {hero.heading_post}
            </h1>

            <p className="mt-5 max-w-xl text-base md:text-lg text-[color:var(--ink-soft)] leading-relaxed">
              {hero.body}
            </p>

            <div className="mt-8 flex flex-wrap items-center gap-3">
              <a data-testid="hero-primary-cta" href="#work" className="mk-btn mk-btn-violet">
                {hero.primary_cta || "See my work"} <ArrowDownRight className="w-4 h-4" />
              </a>
              <a data-testid="hero-secondary-cta" href="#contact" className="mk-btn mk-btn-ghost">
                {hero.secondary_cta || "Say hi"}
              </a>
            </div>
          </div>

          {/* RIGHT: transparent voxel character */}
          <div className="md:col-span-6 lg:col-span-5 flex justify-center md:justify-end">
            {photo && (
              <img
                data-testid="hero-voxel"
                src={resolveImage(photo)}
                alt="Voxel illustration of Misbah at her desk"
                className="w-[min(520px,88vw)] h-auto mk-drift select-none pointer-events-none"
                draggable={false}
              />
            )}
          </div>
        </div>
      </div>
    </section>
  );
};

export default Hero;
